import React from "react";
import "./styles/App.scss";
import Header from "./components/header";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Home from "./components/home";
import Contact from "./components/contact";
import Solutions from "./pages/solutions";
import Blogs from "./pages/blogs";
// import gsap from 'gsap';

// let tl = gsap.timeline();

// const homeAnimation = () => {
// 	tl.from('.line span', 1, {
// 		y: 100,
// 		ease: 'easeInOut',
// 		delay: 1,
// 		stagger: {
// 			amount: 0.3
// 		}
// 	});
// 		.from('.btn-row', 0.3, {
// 			y: 10,
// 			ease: 'Power2.easeInOut',
// 			opacity: 0,
// 			delay: 0
// 		})
// 		.from('.project-h2', 0.2, {
// 			y: 10,
// 			ease: 'easeInOut',
// 			opacity: 0,
// 			delay: 0
// 		})
// 		.from('.case-image img', 1.4, {
// 			scale: 1.4,
// 			ease: 'expo.inOut',
// 			delay: 0,
// 			opacity: 0,
// 			stagger: {
// 				amount: 0.4
// 			}
// 			// onComplete: completeAnimation
// 		})
// 		.from('.btn-group', 0.8, {
// 			y: 10,
// 			ease: 'easeInOut',
// 			scale: 1,
// 			opacity: 0,
// 			delay: 0
// 		});
//};

function App() {
  // let app = useRef(null);

  // useEffect(() => {
  // 	// TweenMax.to(app, 0, { css: { visibility: 'visible' } });
  // 	homeAnimation();
  // });

  return (
    <Router>
      <div className="App">
        <Header />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route
            exact
            path="/solutions"
            component={Solutions}
          />
          <Route exact path="/blogs" component={Blogs} />
          <Route
            exact
            path="/contact"
            component={Contact}
          />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
